import React, { useEffect, useRef, useState } from "react";
import { usePDF, Margin } from 'react-to-pdf';
import { Button, Form, Select, Input, Divider, Collapse, Table, DatePicker } from "antd";
import ProgressModal from '../../../../App/Utils/ProgressModal'
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import SupplierSearchBox from "../../../../Components/SupplierSearchBox";
import { DataProvider } from "../../../DataProvider";
import SafetyFeedback from "../../Components/SafetyFeedback";
import QualityFeedback from "../../Components/QualityFeedback";
import ScheduleFeedback from "../../Components/ScheduleFeedback";
import DisciplineFeedback from "../../Components/DisciplineFeedback";
import ImprovementFeedback from "../../Components/ImprovementFeedback";
import ReactSpeedometer from "react-d3-speedometer";
import { getQuarterReportColumns } from './Constants';
import { useReactToPrint } from "react-to-print";

var _ = require('lodash');
const { Panel } = Collapse;

const QuarterlyReport = (props) => {
    const formRef = useRef();
    const dataProvider = new DataProvider();
    const [weightedScore , setWeightedScore] = useState(0)
    const [showProgress, setShowProgress] = useState(false)
    const [mstProject, setMstProject] = useState([])
    const [feedbackData, setFeedbackData] = useState({})
    const [quarterSelected, setQuarterSelected] = useState(null)
    
    // const { toPDF, targetRef } = usePDF({
    //     filename: 'page.pdf',
    //     page: {
    //         margin: Margin.SMALL,
    //         format: 'A2',
    //     },
    // });

    const targetRef = useRef()

    const handlePrint = useReactToPrint({ contentRef: targetRef });

   
    const fetchDropdownValues = () => {
        ['MstProject'].forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            setMstProject(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    useEffect(() => { fetchDropdownValues() }, [])

    const onFinish = (values) => {
        setFeedbackData({})
        setShowProgress(true)
        values['quarter'] = quarterSelected
        const contractorDetails = JSON.parse(values['contractor_name'])
        values['contractor_code'] = contractorDetails['key']
        dataProvider.getQuarterlyFeedbackReport(values)
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        setShowProgress(false)
                        setFeedbackData(responseJson['results'])
                        setWeightedScore(parseFloat(responseJson['results']['overall_score'].split(' - ')[0]))
                    })
                } else {
                    setShowProgress(false)
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                setShowProgress(false)
                openNotification("error", "Error", "Error connecting server")
            })

    }

    return (
        <div ref={targetRef} id='divToPrint'>
            <ProgressModal showProgress={showProgress} />
            <Form
                className="ant-form ant-form-vertical"
                ref={formRef}
                onFinish={onFinish}>
                <div className="row form-box" style={{ paddingTop: "10px" }}>
                    <div className="col-lg-3 col-md-12">
                        <Form.Item
                            name={"contractor_name"}
                            label="Contractor Name"
                            rules={[{ required: true, message: "Please enter Contractor Name" }]}>
                            <SupplierSearchBox
                                formRef={formRef}
                                mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                                decorator="contractor_name"
                                placeholder="Enter Contractor Name" />
                        </Form.Item>
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Form.Item
                            name={"project"}
                            label="Project"
                            rules={[{ required: true, message: "Please select project" }]}>
                            <Select
                                allowClear
                                showSearch
                                placeholder="Select Project"
                                options={mstProject.map((val) => ({
                                    value: val.project_id,
                                    label: val.project_name,
                                }))} />
                        </Form.Item>
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Form.Item
                            name={"quarter"}
                            label="Quarter"
                            rules={[{ required: true, message: "Please select quarter" }]}>
                                <DatePicker onChange={(date, dateString)=>setQuarterSelected(dateString)} style={{width:"100%"}} picker="quarter" />
                        </Form.Item>
                    </div>

                    <div className="col-lg-2 col-md-12">
                        <div style={{ marginTop: "28px" }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                            >
                                Submit
                            </Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button onClick={handlePrint}>Download Report</Button>
                            
                        </div>
                    </div>
                </div>
            </Form>
            {Object.values(feedbackData).length > 0 && <>
                <div className="row form-box" style={{ paddingTop: "20px" }}>
                    <div className="col-lg-6 col-md-12">
                        <Form.Item
                            extra={<p style={{ fontSize: "13px", paddingLeft: "10px" }}>
                                (0-2)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bronze<br />
                                (2-3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Silver<br />
                                (3-3.5)&nbsp;&nbsp;&nbsp;&nbsp;Gold<br />
                                (3.5-4)&nbsp;&nbsp;&nbsp;&nbsp;Diamond<br />
                            </p>}
                            label="Overall Score">
                            <Input 
                                style={{ color:"white", fontWeight:"bold", background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                                readOnly value={feedbackData['overall_score']} />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-md-12" style={{ textAlign: "center" }}>
                        <ReactSpeedometer
                            currentValueText="Rating Scale"
                            customSegmentStops={[0, 2, 3, 3.5, 4]}
                            segmentColors={["firebrick", "tomato", "gold", "limegreen"]}
                            minValue={0}
                            maxValue={4}
                            height={200}
                            value={feedbackData['overall_score'].split(' - ')[0]}
                        />
                    </div>
                    <Divider />
                    <div className="col-lg-3 col-md-12"></div>
                    <div className="col-lg-6 col-md-12">
                        <Table
                            style={{ marginBottom: "15px" }}
                            bordered={true}
                            columns={getQuarterReportColumns(quarterSelected)}
                            size="small"
                            pagination={false}
                            dataSource={feedbackData['overall_score_category_wise']} />
                    </div>
                    <div className="col-lg-3 col-md-12"></div>
                </div>
                {feedbackData['all_feedbacks'].map((d) => {
                    return <Collapse onChange={false} style={{ margin: "10px" }}>
                        <Panel   header={d['evaluation_period']} style={{ marginBottom: "10px" }}>
                            <Form
                                className="ant-form ant-form-vertical"
                                initialValues={_.cloneDeep(d)}>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12" >
                                        <SafetyFeedback
                                            initialValues={_.cloneDeep(d)}
                                            disabled={true} />
                                    </div>
                                    <div className="col-lg-12 col-md-12" >
                                        <QualityFeedback
                                            initialValues={_.cloneDeep(d)}
                                            disabled={true} />
                                    </div>
                                    <div className="col-lg-12 col-md-12" >
                                        <ScheduleFeedback
                                            initialValues={_.cloneDeep(d)}
                                            disabled={true} />
                                    </div>
                                    <div className="col-lg-12 col-md-12" >
                                        <DisciplineFeedback
                                            initialValues={_.cloneDeep(d)}
                                            disabled={true} />
                                    </div>
                                    <div className="col-lg-12 col-md-12" >
                                        <ImprovementFeedback
                                            initialValues={_.cloneDeep(d)}
                                            disabled={true} />
                                    </div>
                                </div >
                            </Form>
                        </Panel>
                    </Collapse>})}

            </>}
        </div>
    );
};

export default QuarterlyReport;
